import styled from '@emotion/styled'
import { TitleStyled } from '../Utilities/Title/styles'

export const PrimaryTitle = styled(TitleStyled)`
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'bold')};
`
